/* tempexp_18086-start */
import { Icon16ErrorCircleOutline } from '@vkontakte/icons';
import { Text } from '@vkontakte/vkui';
import React, { useCallback } from 'react';
import { getExpiredBonusDays } from 'reactApp/appHelpers/featuresHelpers/features/referralProgram';
import type { BillingReferralProgram } from 'reactApp/modules/billingData/billingData.types';
import { FriendAvatar } from 'reactApp/ui/ReferralProgram/FriendAvatar/FriendAvatar';
import { getPeriodName } from 'reactApp/utils/Period';

import styles from './ReferralUsersBlock.css';

interface ReferralUserItemProps {
    user: BillingReferralProgram;
    onClick(user: BillingReferralProgram): void;
}

export function ReferralUserItem({ user, onClick }: ReferralUserItemProps) {
    const {
        expires,
        quota,
        autorenewable,
        owner: { email },
    } = user;
    const expiredAfterDays = getExpiredBonusDays(expires, autorenewable);
    const handleClick = useCallback(() => {
        onClick(user);
    }, [user, onClick]);
    return (
        <div className={styles.rootItem} onClick={handleClick}>
            <div className={styles.userBlock}>
                <FriendAvatar size={28} info={user} />
                <div className={styles.userInfoBlock}>
                    <Text className={styles.name}>{email}</Text>
                    {expiredAfterDays ? (
                        <Text className={styles.description}>Бонус сгорит через {getPeriodName(`${expiredAfterDays}d`)}</Text>
                    ) : null}
                </div>
            </div>
            <div className={styles.quotaBlock}>
                {expiredAfterDays ? <Icon16ErrorCircleOutline /> : null}
                <Text className={styles.text}>+{quota.value}</Text>
            </div>
        </div>
    );
}

/* tempexp_18086-end */
